import { Button, Col, Divider, Row, Typography } from "antd";
import type { DocumentPackage } from "@/features/supervision-cards-list";
import { PdfIcon } from "@/shared/assets/svg/icons";
import "./notification-view-content.scss";
import { NotificationViewChip } from "./notification-view-chip";

export function NotificationViewContent({ item }: { item: DocumentPackage }) {
  const row = item.table?.[0];
  return (
    <div className="notification-view-content">
      <div className="notification-view-content__chips">
        {item.chippers.map((chip) => (
          <NotificationViewChip
            key={`chip-${chip.text}`}
            backgroundColor={chip.backgroundColor}
          >
            {chip.text}
          </NotificationViewChip>
        ))}
      </div>

      <Typography.Title level={4} className="notification-view-content__title">
        {item.title} {item.textNumber ? `№${item.textNumber}` : ""}
      </Typography.Title>

      <Row gutter={[24, 12]}>
        <Col span={6}>
          <Typography.Text type="secondary">Отправитель</Typography.Text>
          <div>{row?.sender || "-"}</div>
        </Col>
        <Col span={6}>
          <Typography.Text type="secondary">Получатель</Typography.Text>
          <div>{row?.receiver || "-"}</div>
        </Col>
        <Col span={6}>
          <Typography.Text type="secondary">Документ подписан</Typography.Text>
          <div className="notification-view-content__date-time">
            <span>{row?.documentSigned.date}</span>
            <span>{row?.documentSigned.time}</span>
          </div>
        </Col>
        <Col span={6}>
          <Typography.Text type="secondary">Письмо отправлено</Typography.Text>
          <div className="notification-view-content__date-time">
            <span>{row?.letterSent.date}</span>
            <span>{row?.letterSent.time}</span>
          </div>
        </Col>
      </Row>

      <div className="notification-view-content__file-section">
        <div>
          <div className="notification-view-content__file-header">
            <div className="notification-view-content__file-title">
              <PdfIcon />
              <div className="notification-view-content__file-title-text">XML документы</div>
            </div>
            <Button type="link" style={{ fontSize: 12 }}>
              Посмотреть
            </Button>
          </div>
          <ol className="notification-view-content__file-list">
            <li className="notification-view-content__file-item">
              Замечания о регистрации титульного листа.xml
            </li>
            <li className="notification-view-content__file-item">
              Замечания о регистрации титульного листа.xml
            </li>
          </ol>
        </div>
        <Divider />
        <div>
          <div className="notification-view-content__file-header">
            <div className="notification-view-content__file-title">
              <PdfIcon />
              <div className="notification-view-content__file-title-text">
                Приложенные файлы
              </div>
            </div>
          </div>
          <ol className="notification-view-content__file-list">
            <li className="notification-view-content__file-item">
              Подпись и печать.pdf
            </li>
            <li className="notification-view-content__file-item">
              Письмо генерального директора.pdf
            </li>
            <li className="notification-view-content__file-item">
              Претензия на документацию.pdf
            </li>
          </ol>
        </div>
      </div>

      <div className="notification-view-content__actions">
        <Button type="primary">Подписать</Button>
        <Button>Отказаться</Button>
      </div>
    </div>
  );
}

